import { Button } from "@/components/atoms/Buttons/Button";
import { addAlert } from "@/redux/message/messageSlice";
import { AppDispatch } from "@/redux/store";
import {
  TacticsResponses,
  deleteTactic,
  setDeleteTacticStatusIdle,
} from "@/redux/tactics/tacticsSlice";
import { useEffect } from "react";
import { Oval } from "react-loading-icons";
import { useDispatch } from "react-redux";

import ActionModal from "../ActionModal";

interface DeleteTacticsActionModalProps {
  onDismiss: () => void;
  tacticId: string;
  responses: TacticsResponses;
}

const DeleteTacticsActionModal = ({
  onDismiss,
  tacticId,
  responses,
}: DeleteTacticsActionModalProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleDelete = () => {
    dispatch(deleteTactic(tacticId));
  };
  const handleDismiss = () => {
    dispatch(setDeleteTacticStatusIdle());
    onDismiss();
  };

  useEffect(() => {
    if (responses.deleteTactic.status === "fulfilled") {
      dispatch(
        addAlert({
          description: "Tactic deleted successfully",
          type: "success",
        }),
      );
      dispatch(setDeleteTacticStatusIdle());
      handleDismiss();
    }
  }, [responses.deleteTactic.status]);

  return (
    <ActionModal onDismiss={handleDismiss} title={"Delete Tactic"} size="small">
      <div className="flex flex-col gap-y-6 mt-6 items-center">
        <p className="text-gray-200">
          Are you sure you want to delete this tactic? <br /> This will remove
          the tactic for all users.
        </p>
        <div className="flex flex-row gap-x-2">
          <Button onClick={handleDismiss} size="large">
            Cancel
          </Button>
          <Button onClick={handleDelete} size="large" variant="tertiary">
            {responses.deleteTactic.status === "pending" ? (
              <Oval width={20} height={20} />
            ) : (
              "Delete"
            )}
          </Button>
        </div>
        {responses.deleteTactic.message && (
          <span className="text-red-500 text-xs">
            {responses.deleteTactic.message}
          </span>
        )}
      </div>
    </ActionModal>
  );
};

export default DeleteTacticsActionModal;
